module.exports = __webpack_public_path__ + "img/313.b0ba40cb.png";